import axios from "axios";
//import FormData from "form-data";
import {AdminGCListEndPoint, AdminGCMeterEndPoint, AdminAddGCEndPoint, AdminEditGCEndPoint, AdminDeleteGCEndPoint} from "../../../config/AppServerConfig";
import {GlobalConfig} from "./../../../Services/Helper/GlobalConfig";

// axios.interceptors.response.use((response) => {
//   return response;
// }, function (error) {
//   return Promise.reject(error.response);
// });

class AdminGCListServices {
  static getAdminGCList(pageNum) {
    if (!pageNum) {
      pageNum = 1;
    }
    const config = {
      headers: {"Authorization": GlobalConfig.Token}
    };
    return axios.get(AdminGCListEndPoint + "?page=" + pageNum, config);
  }

}
class AdminGCMeterServices {
  static getAdminGCMeter(id) {

    const config = {
      headers: {"Authorization": GlobalConfig.Token}
    };
    return axios.get(AdminGCMeterEndPoint + "/" + id, config);
  }

}

class AdminAddGCServices {
  static addAdminGC(data) {
    const config = {
      headers: {"Authorization": GlobalConfig.Token}
    }
    return axios.post(AdminAddGCEndPoint, data, config)
  }
}

class AdminEditGCServices {
  static editAdminGC(data) {
    const config = {
      headers: {"Authorization": GlobalConfig.Token}
    }
    return axios.put(AdminEditGCEndPoint+"/"+data.id, {name:data.name,params:data.params}, config)
  }
}

class AdminDeleteGCServices {
  static deleteAdminGC(id) {
    const config = {
      headers: {"Authorization": GlobalConfig.Token}
    }
    return axios.delete(AdminDeleteGCEndPoint+"/"+id, config)
  }
}

export {AdminGCListServices, AdminGCMeterServices, AdminAddGCServices, AdminEditGCServices, AdminDeleteGCServices};
